import * as React from 'react';

export function FieldRow({children, className = ''}: { children: React.ReactNode, className?: string }) {
    return <div className={`flex items-end gap-x-2 w-full ${className}`}>{children}</div>;
}
